module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1bQZN"))).then(() => parcelRequire('1iHdE'));